import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

import type { Environment } from '.'

const setDotColor = (env: Environment) => {
  if (env === 'Dev') {
    return css`
      background-color: #378147;
      border: 3px solid #94d1a1;
    `
  }

  return css`
    background-color: #1f58ad;
    border: 3px solid #7da7e8;
  `
}

const setTextColor = (env: Environment) => {
  if (env === 'Dev') {
    return css`
      color: #378147;
    `
  }

  return css`
    color: #1f58ad;
  `
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 6px;
  border-radius: ${theme.shapes.borderRadius.sm};
  margin-right: ${theme.spacing.xm};
  background-color: #ffff;
`

export const Dot = styled.div<{ environment: Environment }>`
  width: 12px;
  height: 12px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;

  ${({ environment }) => setDotColor(environment)}
`

export const Text = styled.span<{ environment: Environment }>`
  margin-left: 4px;
  font-family: ${theme.typography.family.primary};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes['2xs']};
  line-height: normal;

  ${({ environment }) => setTextColor(environment)}
`
